/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "@/src/services/googleAnalyticsService";

const JobPageMeta = () => {
  const title = "Jobs und Karriere | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content="Werde Teil unseres Teams und bewerbe Dich jetzt!" />
      <meta name="keywords" content="Einfache Onlinescheidung, Login, Einloggen, Servicewelt, Kundenbereich" />
      <meta name="robots" content="index,follow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content="Werde Teil unseres Teams und bewerbe Dich jetzt!" />
    </Helmet>
  );
};

export default JobPageMeta;
